import React from 'react'
import {PuntosVenta} from '../components/marketing/PuntosVenta'

export const PuntosVentaPage = () => {
    return (
        <PuntosVenta/>
    )
}
